import { useAsyncExecutor2 } from "async-executor-hook";
import { differenceInDays, format } from "date-fns";
import { stringify } from "query-string";
import { useHistory } from "react-router-dom";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  WForm,
  WFormControl,
} from "rectangular-forms";

import { Authorization } from "../../../common/AuthorizationCpt";
import {
  WCalendar,
  WInputText,
  WMultipleTagInput,
} from "../../../common/components/TemplateContainer/InputTemplates";
import { SaveButton } from "../../../common/components/TemplateContainer/SaveButton";
import { TemplateInputContainer } from "../../../common/components/TemplateContainer/TemplateContainer";
import { removeNullProps } from "../../../common/utils";
import IconVectorRightBlue from "../../../images/icon_button_users_blue.svg";
import { SearchBar } from "../FilterStyles";

export const PaymentPaidSearch = (props) => {
  const { params$ } = props;

  const history = useHistory();

  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        consignee_name: new FormControl(),
        volante_nums: new FormControl(),
        from_date: new FormControl(),
        to_date: new FormControl(),
      });
      form.get("from_date").valueChanges.subscribe((from_date: Date) => {
        const toDate = new Date(form.get("to_date").value) || new Date();
        const diffDate = differenceInDays(toDate, new Date(from_date));
        if (diffDate < 1) {
          form.get("to_date").setValue(from_date);
        }
      });
      form.patchValue(data);
      return form;
    },
    onSubmit: (form) => {
      const data = form.value;
      const from_date = data.from_date && format(data.from_date, "yyyy-MM-dd");
      const to_date = data.to_date && format(data.to_date, "yyyy-MM-dd");
      const pathname = history.location.pathname;
      history.push(
        `${pathname}?${stringify(
          removeNullProps({ ...data, from_date, to_date })
        )}`
      );
    },
  });

  useAsyncExecutor2((params) => params, {
    params$,
    onSuccess: (params) => {
      formConfig.loadSucceed(params);
    },
  });

  return (
    <SearchBar flexStart={false}>
      <WForm formConfig={formConfig} style={{ width: "100%" }}>
        <div
          className="p-grid"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div className="p-col-6 p-md-3">
            <WFormControl name="consignee_name">
              <TemplateInputContainer label="Importador:">
                <WInputText width="100%" placeholder="Nombre del importador" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-6 p-md-3">
            <WFormControl name="volante_nums">
              <TemplateInputContainer label="Volantes:">
                <WMultipleTagInput height="5rem" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-6 p-md-2">
            <WFormControl name="from_date">
              <TemplateInputContainer label="Retiro desde:" color="#08082B">
                <WCalendar width="100%" dateFormat="dd/mm/yy" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-6 p-md-2">
            <WFormControl name="to_date">
              <TemplateInputContainer label="Retiro hasta:">
                <WCalendar
                  width="100%"
                  minDate={
                    formConfig.form?.get("from_date")?.value || new Date()
                  }
                  dateFormat="dd/mm/yy"
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-6 p-md-2">
            <div style={{ marginBottom: "1.8rem", height: "1.4rem" }} />
            <Authorization actions={["quotation.get_quotation_paid_intranet"]}>
              <SaveButton
                label="Aplicar filtros"
                width="100%"
                height="5rem"
                backgroundColor="#002E6C"
                iconRight={IconVectorRightBlue}
              />
            </Authorization>
          </div>
        </div>
      </WForm>
    </SearchBar>
  );
};
